import Vue from 'vue'
import VueRouter from 'vue-router'
import CheckMember from '../views/CheckMember.vue'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import BenefitsInformation from '../views/BenefitsInformation.vue'
import Howto from '../views/Howto.vue'
import Term from '../views/Term.vue'
import Register from '../views/Register.vue'
import Profile from '../views/Member/Profile.vue'
import Accumulate from '../views/Member/Accumulate.vue'
import Benefits from '../views/Member/Benefits.vue'
import MemberExpired from '../views/Member/MemberExpired.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'CheckMember',
    component: CheckMember
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/benefits-information',
    name: 'BenefitsInformation',
    component: BenefitsInformation
  },
  {
    path: '/howto',
    name: 'Howto',
    component: Howto
  },
  {
    path: '/term',
    name: 'Term',
    component: Term
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/accumulate',
    name: 'Accumulate',
    component: Accumulate
  },
  {
    path: '/benefits',
    name: 'Benefits',
    component: Benefits
  },
  {
    path: '/member-expired',
    name: 'MemberExpired',
    component: MemberExpired
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
